export default __webpack_public_path__ + "static/11-bb449d146ee4381223c878bb4e1d8a5f.webp";